import { dialogAllocateInfoErrorType } from '@/constants';
import { allocateWorkerType } from '@/constants/global';
import { i18n } from '@/locales';
const lc = 'views.map_control.dialog_allocation_alert.';
const titleData = {
    success: {
        [allocateWorkerType.IMMEDIATE]: 'success_immediate_allocate',
        [allocateWorkerType.REQUEST_ALLOCATE]: 'success_request_allocate',
    },
    error: {
        [allocateWorkerType.REALLOCATE]: dialogAllocateInfoErrorType.FAIL_REALLOCATE,
        [allocateWorkerType.IMMEDIATE]: dialogAllocateInfoErrorType.FAIL_IMMEDIATE_ALLOCATE,
        [allocateWorkerType.REQUEST_ALLOCATE]: dialogAllocateInfoErrorType.FAIL_REQUEST_ALLOCATE,
    },
    accept: {
        [allocateWorkerType.REQUEST_ALLOCATE]: 'accept_request_allocate',
    },
    reject: {
        [allocateWorkerType.REQUEST_ALLOCATE]: 'reject_request_allocate',
    },
};
/**
 * 팝업 제목 조회
 * @param resultType
 * @param allocateType
 * @returns
 */
export const getTitle = (resultType, allocateType) => titleData[resultType][allocateType];
/**
 * 팝업 메시지 조회
 * @param allocateEventType
 * @param objectAgencyOptions
 * @returns
 */
export const getMessage = (allocateEventType, _agencyShareInfo) => {
    const agencyShareInfo = _agencyShareInfo || {
        allocateLimit: -1,
        serviceLevelAgreementDeliveryTime: -1,
    };
    const { allocateLimit, serviceLevelAgreementDeliveryTime: sla, } = agencyShareInfo;
    const isBundle = allocateLimit > 1 ? 1 : 0;
    const message = [];
    if (allocateLimit < 0
        || sla < 0) {
        message.push('테스트중');
        return message.join(' ');
    }
    switch (allocateEventType) {
        // 즉시배차 성공
        case allocateWorkerType.IMMEDIATE:
            message.push(i18n.t(`${lc}immediate_success`, isBundle));
            message.push(i18n.t(`${lc}please_complete_on_time`, [
                sla,
            ]));
            break;
        // 배차요청 성공
        case allocateWorkerType.REQUEST_ALLOCATE:
            message.push(i18n.t(`${lc}request_success`, isBundle));
            break;
        // 배차요청 수락
        case 'REQUEST_ACCEPT':
            message.push(i18n.t(`${lc}request_accept`, isBundle));
            message.push(i18n.t(`${lc}please_complete_on_time`, [
                sla,
            ]));
            break;
        default: break;
    }
    return message.join(' ');
};
